import I18n from "i18n-js";
import _ from "lodash";

const titles = new Intl.DisplayNames([I18n.locale], { type: "language" });

export const getLocaleTitle = (locale) => {
  const title = titles.of(locale).split(" ");
  return `${_.capitalize(title[0])} ${title[1] || ""}`;
}